/**
 * @module app.bdc.reports.exportJDSCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ExportJDSCtrl(
        $scope,
        $window,
        $rootScope,
        reportRoutingService,
        goodwillGesturesService,
        orderService,
        unitBonusService,
        pricesService,
        tillPackService,
        userService,
        exportService,
        offerService,
        promotionService
    ) {
        var self = {};

        self.rds = $rootScope.user;
        self.drv = $rootScope.parent;

        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/bdc/list');
        }

        // Order type used to adapt jds columns to the order type
        // self.jdsOrderType = $rootScope.jdsOrderType;
        // self.jdsOfferType = $rootScope.jdsOfferType;
        // self.isExportJdsTrad = $rootScope.isExportJdsTrad;

        // if (!self.jdsOrderType && !self.jdsOfferType) {
        //     return $scope.goTo('/bdc/list');
        // }

        // self.isNAP = self.jdsOrderType === 'NAP';
        // self.isTRAD = self.jdsOrderType === 'TRAD';

        self.orders = $rootScope.orders;
        self.contractMonths = (order) => { return orderService.getContractMonths(order)};

        self.formatNumber = (number) => {
            return number ? number.toString().replace(/\./g, ',') : number;
        }

        self.getAmountFinanced = (order) => {
            return (order.contract.nbMonthsFidelity * order.contract.previousInstallment + orderService.getContractMonths(order) * order.prices.leaserSubtotal)
                / (orderService.getContractMonths(order) + order.contract.nbMonthsFidelity);
        }

        self.getTotalAmountFinanced = (order) => {
            return self.getAmountFinanced(order) / pricesService.RENTAL_LEASER[order.contract.nbMonthsFidelity + self.contractMonths(order)];
        }

        self.reportRouting = reportRoutingService;
        self.exportService = exportService;

        self.is2017Offer = function is2017Offer(order) {
            return tillPackService.is2017TillPack(order.tills, order.orderType.code);
        };

        /**
         * Get the title to display at the top of the export
         * If the offer type is material till, we display a certain value, otherwise the orderType is displayed
         * @return {String}
         */
        self.titleToDisplay = function() {
            return self.jdsOfferType === 'materialTill' ? 'Caisse Lourde Fleuriste' : self.jdsOrderType;
        };

        /**
         * Get date fr signature
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getDateSignature = function getDateSignature(date) {
            return date ? moment(date).format('DD/MM/YYYY') : date;
        };

        /**
         * Get date fr signature
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getMonthNumberDateSignature = function getMonthNumberDateSignature(date) {
            return date ? moment(date).format('M') : date;
        };

        /**
         * Get RDS to display
         * @param  {String} rdsRef
         * @return {String}
         */
        self.getRDS = function getRDS(rdsRef) {
            var rds = userService.findPerson(rdsRef);
            return rds ? rds.user.firstname + ' ' + rds.user.lastname : rdsRef;
        };

        /**
         * Display DRV name
         * @param  {String} drvRef
         * @return {String}
         */
        self.getDRV = function getDRV(drvRef) {
            var drv = userService.findPerson(drvRef);
            return drv ? drv.user.firstname + ' ' + drv.user.lastname : drvRef;
        };

        /**
         * Get nb Options
         * @param  {Array}  options
         * @param  {String}  type : optionType -> TPE, SCANUP, ...
         * @return {int}
         */
        self.getNbOptions = function getNbOptions(options, type) {
            var nbOptions = 0;
            for (var i = 0; i < options.length; i++) {
                for (var j = 0; j < self.orderForm.options.length; j++) {
                    if (
                        options[i].id === self.orderForm.options[j].id &&
                        self.orderForm.options[j].optionType.code === type
                    ) {
                        if (type === 'TPE') {
                            nbOptions += self.orderForm.options[j].isTPEDevice ? options[i].nbOptions : 0;
                        }
                        else if (type === 'SCANUP') {
                            nbOptions += self.orderForm.options[j].isScanupDevice ? options[i].nbOptions : 0;
                        }
                        else {
                            nbOptions += options[i].nbOptions;
                        }
                    }
                }
            }

            return nbOptions;
        };

        /**
         * Counts the number of Scan up, including the one in the pack
         * @param {Array} order
         * @returns {number}
         */
        self.getNbScanUp = function getNbScanUp(order) {
            var nbScanUp = 0;

            // Count all the options that have the type 'SCANUP'
            nbScanUp += self.getNbOptions(order.options, 'SCANUP', false);

            // Only for NAP
            // If the offer has a Scan up included, it needs to be added to the final count
            if (order.orderType.code === 'NAP') {
                nbScanUp += order.contract.isScanupIncluded ? 1 : 0;
            }

            return nbScanUp;
        };

        self.getNbClubBimediaPoints = function (order){
            let point = 0
            if(order.orderType.code !== 'NAP'){
                if(order.goodwillGestures && order.goodwillGestures.amount.clubBimedia > 7 && !order.goodwillGestures.generosity.renunciationClubBimedia)
                    point += order.goodwillGestures.amount.clubBimedia;
                if(order.goodwillGestures && order.goodwillGestures.amount.clubBimediaEncaissementMobile > 0)
                    point += order.goodwillGestures.amount.clubBimediaEncaissementMobile;
                if(order.sponsor && order.sponsor.gift === 'GLADY')
                    point += 100;
            }
            return point
        }

        /**
         * Get DRV budget to display
         * @param  {Object} drvBudget
         * @return {String}
         */
        self.getDRVBudget = function getDRVBudget(drvBudget) {
            if (!drvBudget) {
                return '';
            }

            for (var j = 0; j < self.orderForm.drvBudget.length; j++) {
                if (drvBudget.id === self.orderForm.drvBudget[j].id) {
                    return self.orderForm.drvBudget[j].label;
                }
            }
        };

        /**
         * Return pack type from the label
         * @param  {Object} order
         * @param  {String} type  Option Type
         * @return {String}   return option's label last word ('essentiel' or 'premium' for packs)
         */
        self.getPackType = function getPackType(order, type) {
            var pack = order.options.find(function(option) {
                return option.optionType.code === type;
            });
            if (!pack || offerService.isOlderOffer(order) === true) {
                return '';
            }
            var label = self.orderForm.options.find(function(option) {
                return option.id === pack.id;
            }).label;
            return label.slice(label.lastIndexOf(' '));
        };

        /**
         * Get date installation
         * @param {String} date
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation(date) {
            return date
                ? moment(date, 'YYYY-MM-DD')
                    .format('MMMM YYYY')
                    .toUpperCase()
                : null;
        };

        self.getDate = function getDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        };

        self.getNBTills = function getNBTills(tills) {
            return orderService.getNbTills(tills);
        };

        self.getNbTillsByTillType = function getNbTillsByTillType(order) {
            return orderService.getNbTillsByTillType(order.tills);
        };

        self.getMaintenancePercentDiscount = function getMaintenancePercentDiscount(order) {
            var option = order.options.find(function(option) {
                return option.optionType.code === 'MAINTENANCE' && option.discount > 0;
            });

            if (typeof option !== 'undefined') {
                return option.discount;
            }
            else {
                return 0;
            }
        };

        self.isVip = function (order) {
            const segments = [
                'A : + de 300K Hab.',
                'B : + de 150K Hab.',
                'C : + de 100K Hab.',
                'D : + de 50K Hab.',
                'E : + de 40K Hab.']
            return segments.includes(order.client.segment) ? order.client.segment
                : self.getNBTills(order.tills) >= 3 ? self.getNBTills(order.tills) + ' caisses' : 'NON';
        }

        /**
         * Check if the order has an option with the code givien in parameter
         * @param order
         * @param code
         * @returns {boolean}
         */
        self.hasOptionCode = function (order, code) {
            var opt = self.orderForm.options.find(function(option) {
                return option.code === code && option.orderType.code === order.orderType.code;
            });

            let optionId = opt ? opt.id : null;

            var option = optionId ? order.options.find(function(obj) {
                return optionId === obj.id;
            }) : undefined;

            return typeof option !== 'undefined';
        };

        self.availableTills = self.orderForm.tills.filter(function(till) {
            return till.orderType.code === self.jdsOrderType && till.isDeleted === false;
        });

        self.totalAmountTills = 0;
        self.totalAmountEssentielPacks = 0;
        self.totalAmountPremiumPacks = 0;
        self.totalAmountRefubishedPacks = 0;
        self.totalAmountMaintenancePackagePacks = 0;
        self.totalAmountScanups = 0;
        self.totalAmountDefautOptions = 0;

        self.averageMonthsReintegration = 0;
        self.averageMonthsFidelity = 0;
        self.averageMonthsCalage = 0;
        self.averagePartExchange = 0;
        self.averageOfferedTPE = 0;
        self.averageMDS = 0;
        self.averageRevenue = 0;
        self.averageGGTotal = 0;
        self.averageGGTotalWithoutRevenue = 0;

        function _initTotals() {
            var totalNBMonths = 0;
            var totalNBMonthsFidelity = 0;
            var totalNBMonthsCalage = 0;
            var totalPartExchange = 0;
            var totalOfferedTPE = 0;
            var totalMDS = 0;
            var totalRevenue = 0;
            var totalNBMDS = 0;
            var totalRevenueAcc = 0;
            var totalRevenueStimul = 0;

            for (var i = 0; i < self.orders.length; i++) {
                // Parse orderForm to get missing options keys: optionType and prices
                self.orders[i].options.forEach(function(orderOption) {
                    var optionInfos = $rootScope.orderForm.options.find(function(formOption) {
                        return formOption.id === orderOption.id;
                    });
                    orderOption.optionType = optionInfos ? optionInfos.optionType : '';
                    orderOption.prices = optionInfos ? optionInfos.prices : [];
                });

                // Parse orderForm to get missing tills key: tillType
                self.orders[i].tills.forEach(function(orderTill) {
                    var tillsInfos = $rootScope.orderForm.tills.find(function(formTills) {
                        return formTills.id === orderTill.id;
                    });
                    if (tillsInfos) {
                        orderTill.tillType = {
                            id: tillsInfos.tillType.id,
                            code: tillsInfos.tillType.code,
                            label: tillsInfos.tillType.label
                        };
                    }
                    else {
                        orderTill.tillType = {
                            id: null,
                            code: null,
                            label: null
                        };
                    }
                });

                // Récupération des infos des promotions
                self.orders[i].promotions = promotionService.mapOrderFormData(
                    self.orders[i].promotions,
                    self.orderForm.promotions
                );

                for (var j = 0; j < self.orders[i].tills.length; j++) {
                    self.totalAmountTills += self.orders[i].tills[j].nbTills;

                    if (self.orders[i].tills[j].tillType.code === 'ESSENTIEL') {
                        self.totalAmountEssentielPacks += self.orders[i].tills[j].nbTills;
                    }
                    if (self.orders[i].tills[j].tillType.code === 'PREMIUM') {
                        self.totalAmountPremiumPacks += self.orders[i].tills[j].nbTills;
                    }
                    if (self.orders[i].tills[j].tillType.code === 'FORFAIT') {
                        self.totalAmountMaintenancePackagePacks += self.orders[i].tills[j].nbTills;
                    }
                    if (self.orders[i].tills[j].tillType.code === 'PREMIUM_RECONTIONNE') {
                        self.totalAmountRefubishedPacks += self.orders[i].tills[j].nbTills;
                    }
                }

                for (var k = 0; k < self.orders[i].options.length; k++) {
                    for (var l = 0; l < self.orderForm.options.length; l++) {
                        if (
                            self.orders[i].options[k].id === self.orderForm.options[l].id &&
                            self.orderForm.options[l].isScanupDevice
                        ) {
                            self.totalAmountScanups += self.orders[i].options[k].nbOptions;
                        }

                        if (
                            self.orders[i].options[k].id === self.orderForm.options[l].id &&
                            self.orderForm.options[l].optionType.code === 'DEFAUT'
                        ) {
                            self.totalAmountDefautOptions += self.orders[i].options[k].nbOptions;
                        }
                    }
                }

                totalNBMonths += self.orders[i].contract.nbMonths ? self.orders[i].contract.nbMonths : 0;
                totalNBMonthsFidelity += self.orders[i].contract.nbMonthsFidelity
                    ? self.orders[i].contract.nbMonthsFidelity
                    : 0;
                totalNBMonthsCalage += self.orders[i].contract.nbMonthsCalage
                    ? self.orders[i].contract.nbMonthsCalage
                    : 0;
                totalPartExchange += self.orders[i].goodwillGestures
                    ? self.orders[i].goodwillGestures.amount.tillPartExchange +
                      self.orders[i].goodwillGestures.amount.scanupPartExchange
                    : 0;

                totalOfferedTPE += self.orders[i].goodwillGestures ? self.orders[i].goodwillGestures.amount.tpe : 0;
                totalMDS += self.orders[i].goodwillGestures ? self.orders[i].goodwillGestures.amount.mds : 0;
                totalRevenue += self.orders[i].goodwillGestures ? self.orders[i].goodwillGestures.amount.revenue : 0;
                totalNBMDS += self.orders[i].goodwillGestures
                    ? self.orders[i].goodwillGestures.mds.nbMDSRDS + self.orders[i].goodwillGestures.mds.nbMDSDRV
                    : 0;
                totalRevenueAcc +=
                    self.orders[i].goodwillGestures &&
                    self.orders[i].goodwillGestures.revenue.typeCode === 'ACCELERATEUR'
                        ? self.orders[i].goodwillGestures.revenue.rateValue
                        : 0;
                totalRevenueStimul +=
                    self.orders[i].goodwillGestures &&
                    self.orders[i].goodwillGestures.revenue.typeCode === 'STIMULATEUR'
                        ? self.orders[i].goodwillGestures.revenue.rateValue
                        : 0;

                // Unit Bonus
                var totalUnitBonus = 0;
                totalUnitBonus += self.orders[i].unitBonus.hardAndSoft
                    ? parseFloat(self.orders[i].unitBonus.hardAndSoft)
                    : 0;
                totalUnitBonus += self.orders[i].unitBonus.maintenance
                    ? parseFloat(self.orders[i].unitBonus.maintenance)
                    : 0;
                totalUnitBonus += self.orders[i].unitBonus.tpe ? parseFloat(self.orders[i].unitBonus.tpe) : 0;
                self.orders[i].unitBonus.total = totalUnitBonus;
            }

            self.averageMonthsReintegration = totalNBMonths / self.orders.length;
            self.averageMonthsFidelity = totalNBMonthsFidelity / self.orders.length;
            self.averageMonthsCalage = totalNBMonthsCalage / self.orders.length;
            self.averagePartExchange = totalPartExchange / self.orders.length;
            self.averageOfferedTPE = totalOfferedTPE / self.orders.length;
            self.averageMDS = totalMDS / self.orders.length;
            self.averageRevenue = totalRevenue / self.orders.length;
            self.averageGGTotal = (totalPartExchange + totalOfferedTPE + totalMDS + totalRevenue) / self.orders.length;
            self.averageGGTotalWithoutRevenue = (totalPartExchange + totalOfferedTPE + totalMDS) / self.orders.length;
            self.averageNBMDS = totalNBMDS / self.orders.length;
            self.averageRevenueAcc = totalRevenueAcc / self.orders.length;
            self.averageRevenueStimul = totalRevenueStimul / self.orders.length;
        }

        self.displaySponsorInfos = function displaySponsorInfos(order) {
            if (order.sponsorName !== null) {
                return order.sponsorName;
            }
            else {
                return orderService.getSponsorInfos(order.sponsor).reduce(function(acc, curr, index) {
                    return acc + ' ' + curr;
                }, '');
            }
        };

        _initTotals();

        return self;
    }

    ExportJDSCtrl.$inject = [
        '$scope',
        '$window',
        '$rootScope',
        'reportRoutingService',
        'goodwillGesturesService',
        'orderService',
        'unitBonusService',
        'pricesService',
        'tillPackService',
        'userService',
        'exportService',
        'offerService',
        'promotionService'
    ];

    angular.module('app.bdc.reports.exportJDSCtrl', []).controller('ExportJDSCtrl', ExportJDSCtrl);
});
